import React, { useEffect, useRef } from 'react';
import { animate, useInView } from 'framer-motion';

interface Props {
  num: number;
  suffix: string;
  decimals?: number;
  subheading: string;
}

export const Stat = ({ num, suffix, decimals = 0, subheading }: Props) => {
  const ref = useRef<HTMLSpanElement | null>(null);
  const isInView = useInView(ref);

  useEffect(() => {
    if (!isInView) return;

    animate(0, num, {
      duration: 2,
      onUpdate(value) {
        if (!ref.current) return;

        ref.current.textContent = value.toFixed(decimals);
      },
    });
  }, [num, decimals, isInView]);

  return (
    <div className="flex w-72 items-center py-8 sm:py-0 gap-4">
      <p className="text-center font-semibold text-5xl">
        <span className="text-[#FAED04]" ref={ref}></span>
      </p>
      <p className="flex flex-col max-w-48  text-neutral-400">
        <span className="text-2xl">{suffix}</span>
        <span className="text-3xl">{subheading}</span>
      </p>
    </div>
  );
};
